import React, {useState, useEffect, useRef} from 'react'
import Helmet from 'react-helmet'
import useConfig from 'Src/utilities/useConfig'

const isProduction = process.env.NODE_ENV === 'production'

export const THEMES = {
  a2z: {
    name: 'A2Z',
    stylesheets: [
      'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700&display=swap',
    ],
  },
  mazda: {
    name: 'Mazda',
    stylesheets: isProduction
      ? [`/static/theme-mazda.css?t=${new Date().toJSON().slice(0, 10)}`] // Prints YYYY-MM-DD
      : [],
  },
}

type TThemeKey = keyof typeof THEMES

const getThemeClassName = (themeKey: TThemeKey) => `theme--${themeKey}`

const Theme = () => {
  const {theme} = useConfig()
  const [themeKey, setThemeKey] = useState<TThemeKey>('a2z')
  const previousThemeKeyRef = useRef<TThemeKey | undefined>(undefined)

  useEffect(() => {
    if (theme in THEMES) {
      previousThemeKeyRef.current = themeKey
      setThemeKey(theme)
    }
  }, [theme])

  useEffect(() => {
    if (previousThemeKeyRef.current) {
      document.documentElement.classList.remove(getThemeClassName(previousThemeKeyRef.current))
    }

    document.documentElement.classList.add(getThemeClassName(themeKey))
  }, [themeKey])

  return (
    <Helmet>
      {THEMES[themeKey].stylesheets.map((stylesheet) => (
        <link key={stylesheet} href={stylesheet} rel="stylesheet" />
      ))}
    </Helmet>
  )
}

export default Theme
